<template>
<div>
  <!-- <vs-row id="staff-info" class="pb-2 border-bottom-custom">
    <vs-col class="w-1/5 flex flex-col align-center py-6 px-3">
      <vs-avatar size="92px" :src="activeStaffData.image_url" :text="StringHelper.changeFormatAvatar(activeStaffData.name)" class="m-0 text-5xl" :color="activeStaffData.color_code" />
    </vs-col>
    <vs-col class="w-4/5 py-6 px-3 staff-info" style="font-size: 14px;">
      <vs-row class="pt-0 pb-5">
        <vs-col class="title-width-custom pr-3">Staff name:</vs-col>
        <vs-col class="content-width-custom">{{activeStaffData.name}}</vs-col>
      </vs-row>
      <vs-row class="pt-0 pb-5">
        <vs-col class="title-width-custom pr-3">Staff code:</vs-col>
        <vs-col class="content-width-custom">{{StringHelper.staffCodeFormat(activeStaffData.code)}}</vs-col>
      </vs-row>
      <vs-row class="pt-0 pb-5">
        <vs-col class="title-width-custom pr-3">Active status:</vs-col>
        <vs-col class="content-width-custom flex justify-between p-0">
          <div style="width: 140px">
            <vs-switch v-model="staff_status" @click="openPopupChangeStatus" class="mr-base"/>
            <vs-popup class="holamundo change-staff-status-popup" title="Change Staff Status" :active.sync="popupActive">
              <div class="text-center">
                <h3>Do you want to<span v-if="staff_status"> inactive </span><span v-else> active </span>this staff?</h3>
                <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                  <vs-button class="mr-6 align-center change-status-responsive" @click.stop="changeStatus">Change</vs-button>
                  <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="closePopup">Cancel</vs-button>
                </div>
              </div>
            </vs-popup>
          </div>

          <vs-row class="content-width-custom" v-if="config.appointment_feature == 1">
            <vs-col class="title-width-custom p-0 pr-3">Booking staff:</vs-col>
            <vs-col class="content-width-custom p-0">
              <vs-switch v-model="booking_active" @click="changeBookingActive" />
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>

      <vs-button type="filled" color="primary" class="mt-4" @click="editData" style="margin: 0 25%;">Edit information</vs-button>
    </vs-col>
  </vs-row> -->

  <div id="staff-info" class="flex pb-2">
    <div class="w-1/6 flex flex-col align-center py-6 pr-3">
      <vs-avatar size="92px" :src="activeStaffData.image_url" :text="StringHelper.changeFormatAvatar(activeStaffData.name)" class="m-0 text-5xl" :color="activeStaffData.color_code" />
    </div>

    <div class="flex flex-wrap w-5/6 py-6 staff-info" style="font-size: 14px;">
      <!-- <div class="w-1/2 flex pt-0 pb-3 px-1">
        <div class="title-width-custom pr-3">Username:</div>
        <div class="content-width-custom">Huong Ana</div>
      </div> -->

      <div class="w-1/2 flex pt-0 pb-3 px-1">
        <div class="title-width-custom pr-3">Name:</div>
        <div class="content-width-custom">{{activeStaffData.name}}</div>
      </div>

      <div class="w-1/2 flex pt-0 pb-3 px-1">
        <div class="title-width-custom pr-3">Type:</div>
        <div class="content-width-custom">Staff</div>
      </div>

      <div class="w-1/2 flex pt-0 pb-3 px-1">
        <div class="title-width-custom pr-3">Nick name:</div>
        <div class="content-width-custom" v-if="activeStaffData.nickname && activeStaffData.nickname != ''">{{activeStaffData.nickname}}</div>
        <div class="content-width-custom" v-else>N/A</div>
      </div>

      <div class="w-1/2 flex pt-0 pb-3 px-1">
        <div class="title-width-custom pr-3">Code:</div>
        <div class="content-width-custom">{{StringHelper.staffCodeFormat(activeStaffData.code)}}</div>
      </div>

      <div class="w-1/2 flex pt-0 pb-3 px-1">
        <div class="title-width-custom pr-3">Cell:</div>
        <div class="content-width-custom" v-if="activeStaffData.phone && activeStaffData.phone != ''">{{StringHelper.phoneNumberFormat(activeStaffData.phone)}}</div>
        <div class="content-width-custom" v-else>N/A</div>
      </div>

      <div class="w-1/2 flex pt-0 pb-3 px-1">
        <div class="title-width-custom pr-3">Email:</div>
        <div class="content-width-custom">{{activeStaffData.email}}</div>
      </div>


      <div class="w-full flex pt-0 pb-3 px-1">
        <div class="title-width-custom pr-3">Address:</div>
        <div class="content-width-custom" v-if="activeStaffData.address && activeStaffData.address != ''">{{activeStaffData.address}}</div>
        <div class="content-width-custom" v-else>N/A</div>
      </div>


      <!-- <div class="w-1/2 flex pt-0 pb-3 px-1">
        <div class="title-width-custom pr-3">Salary:</div>
        <div class="content-width-custom">50</div>
      </div> -->


      <!-- <div class="w-1/2 flex pt-0 pb-3 px-1">
        <div class="title-width-custom pr-3">Time keeping:</div>
        <div class="content-width-custom">Out</div>
      </div> -->


      <!-- <div class="w-1/2 flex pt-0 pb-3 px-1">
        <div class="title-width-custom pr-3">Time keeping at:</div>
        <div class="content-width-custom">2020-07-01 T04:00:00Z</div>
      </div> -->

      <div class="flex w-full">
        <div class="w-1/2 flex pt-0 pb-5 px-1">
          <div class="title-width-custom pr-3">Active status:</div>
          <div class="content-width-custom">
            <vs-switch v-model="staff_status" @click="openPopupChangeStatus" class="mr-base"/>
            <vs-popup class="holamundo change-staff-status-popup" title="Change Staff Status" :active.sync="popupActive">
              <div class="text-center">
                <h3>Do you want to<span v-if="staff_status"> inactive </span><span v-else> active </span>this staff?</h3>
                <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                  <vs-button class="mr-6 align-center change-status-responsive" @click.stop="changeStatus">Change</vs-button>
                  <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="closePopup">Cancel</vs-button>
                </div>
              </div>
            </vs-popup>
          </div>
        </div>

        <div class="w-1/2 flex pt-0 pb-5 px-1" v-if="config.appointment_feature == 1">
          <div class="title-width-custom p-0 pr-3">Booking staff:</div>
          <div class="content-width-custom p-0">
            <vs-switch v-model="booking_active" @click="changeBookingActive" />
          </div>
        </div>
      </div>


      <vs-button type="filled" color="primary" class="mt-4" @click="editData" style="margin: 0 25%;">Edit information</vs-button>
    </div>
  </div>

  <div v-if="config.pos_feature == 1">
  <div id="staff-info-pos" class="flex justify-between border-top-custom pt-4">
    <div>
      <vs-row>
        <div class="mt-4" style="position: relative;">
          <vs-button type="border" color="primary" class="no-shadow tab-btn" v-if="type == 'commission'">Commission</vs-button>
          <vs-button type="filled" color="#D1D1D1" class="no-shadow tab-btn" v-else @click="type = 'commission'">Commission</vs-button>
          <div style="position: absolute; z-index: 3;top: -10px;right: -10px;">
            <div class="staff-info-circle" @click="staffSettingCommission(staff_setting_type = 'commission')">
              <i class="vs-icon cursor-pointer user-select-none material-icons small bg-medium ml-1 mt-1" style="color: white" v-if="commission_type == 'commission'">check</i>
            </div>
          </div>
        </div>
        <div class="mt-4" style="position: relative;">
          <vs-button type="border" color="primary" class="no-shadow tab-btn not-first-btn" v-if="type == 'salary_commission'">Salary + Commission</vs-button>
          <vs-button type="filled" color="#D1D1D1" class="no-shadow tab-btn not-first-btn" v-else @click="type = 'salary_commission'">Salary + Commission</vs-button>
          <div style="position: absolute; z-index: 3;top: -10px;right: -10px;">
            <div class="staff-info-circle" @click="staffSettingSalaryCommission(staff_setting_type = 'salary_commission')">
              <i class="vs-icon cursor-pointer user-select-none material-icons small bg-medium ml-1 mt-1" style="color: white" v-if="commission_type == 'salary_commission'">check</i>
            </div>
          </div>
        </div>
        <div class="mt-4" style="position: relative;">
          <vs-button type="border" color="primary" class="no-shadow tab-btn not-first-btn" v-if="type == 'salary'">Salary</vs-button>
          <vs-button type="filled" color="#D1D1D1" class="no-shadow tab-btn not-first-btn" v-else @click="type = 'salary'">Salary</vs-button>
          <div style="position: absolute; z-index: 3;top: -10px;right: -10px;">
            <div class="staff-info-circle" @click="staffSettingSalary(staff_setting_type = 'salary')">
              <i class="vs-icon cursor-pointer user-select-none material-icons small bg-medium ml-1 mt-1" style="color: white" v-if="commission_type == 'salary'">check</i>
            </div>
          </div>
        </div>
      </vs-row>
    </div>
    <div class="pl-5">
      <vs-button type="border" color="primary" class="mt-4 gradient gradient-primary no-shadow" @click="editCommission">Edit</vs-button>
    </div>
  </div>
  <vs-popup class="holamundo delete-staff-popup" title="Change Staff Setting" :active.sync="popupStaffSetting">
      <div class="text-center">
          <img src="../../assets/images/setting.png">
          <h3 class="mt-2">Are you sure you want to set Commission for this staff?</h3>
          <div class="flex flex-wrap justify-center align-center p-6 mt-4">
          <vs-button class="mr-6 align-center delete-responsive" @click="changeStaffSetting">Yes</vs-button>
          <vs-button type="border" color="primary" class="cancel-responsive" @click="popupStaffSetting = false">No</vs-button>
          </div>
      </div>
  </vs-popup>

  
    <div class="flex justify-between pb-base" v-if="type == 'commission'">
        <div v-if="this.commissionList.commission != null">
          <h5 class="font-bold pt-base">Employee - Owner Commission</h5>
          <div class="flex">
            <div style="margin-right: 70px;">
              <p class="mt-5 mb-3">For Service</p>
              <p class="font-bold text-primary">{{formatPercent(this.commissionList.commission.service_rate)}} - {{formatPercent(1 - this.commissionList.commission.service_rate)}}</p>
            </div>

            <div style="margin-right: 70px;">
              <p class="mt-5 mb-3">For Product</p>
              <p class="font-bold text-primary">{{formatPercent(this.commissionList.commission.product_rate)}} - {{formatPercent(1 - this.commissionList.commission.product_rate)}}</p>
            </div>

            <div style="margin-right: 70px;">
              <p class="mt-5 mb-3">For Giftcard</p>
              <p class="font-bold text-primary">{{formatPercent(this.commissionList.commission.gift_card_rate)}} - {{formatPercent(1 - this.commissionList.commission.gift_card_rate)}}</p>
            </div>
          </div>

          <h5 class="font-bold pt-base">Cash - Check Percentage</h5>
          <p class="font-bold text-primary mt-3">{{formatPercent(this.commissionList.commission.cash_check_percentage)}} - {{formatPercent(1 - this.commissionList.commission.cash_check_percentage)}}</p>

          <h5 class="font-bold pt-base">Percentage Charge For Credit Card Tips</h5>
          <p class="font-bold text-primary mt-3">{{formatFloatNum(this.commissionList.commission.tip_to_check_percentage)}}%</p>

        </div>
        <div v-else>
          <h5 class="font-bold pt-base">Commission not found for staff</h5>
        </div>
    </div>
    <div v-if="type == 'salary_commission'">
      <div v-if="this.commissionList.salary_commission != null">
          <h5 class="font-bold pt-base">Salary by period</h5>
          <p class="font-bold text-primary mt-3">{{+(Math.round(this.commissionList.salary_commission.salary_by_period + "e+3") + "e-3")}}
          <h5 class="font-bold pt-base">Employee - Owner Commission</h5>
          <div class="flex">
            <div style="margin-right: 70px;">
              <p class="mt-5 mb-3">For Service</p>
              <p class="font-bold text-primary">{{formatPercent(this.commissionList.salary_commission.service_rate)}} - {{formatPercent(1 - this.commissionList.salary_commission.service_rate)}}</p>
            </div>

            <div style="margin-right: 70px;">
              <p class="mt-5 mb-3">For Product</p>
              <p class="font-bold text-primary">{{formatPercent(this.commissionList.salary_commission.product_rate)}} - {{formatPercent(1 - this.commissionList.salary_commission.product_rate)}}</p>
            </div>

            <div style="margin-right: 70px;">
              <p class="mt-5 mb-3">For Giftcard</p>
              <p class="font-bold text-primary">{{formatPercent(this.commissionList.salary_commission.gift_card_rate)}} - {{formatPercent(1 - this.commissionList.salary_commission.gift_card_rate)}}</p>
            </div>
          </div>

          <h5 class="font-bold pt-base">Cash - Check Percentage</h5>
          <p class="font-bold text-primary mt-3">{{formatPercent(this.commissionList.salary_commission.cash_check_percentage)}} - {{formatPercent(1 - this.commissionList.salary_commission.cash_check_percentage)}}</p>

          <h5 class="font-bold pt-base">Percentage Charge For Credit Card Tips</h5>
          <p class="font-bold text-primary mt-3 mb-6">{{formatFloatNum(this.commissionList.salary_commission.tip_to_check_percentage)}}%</p>

        </div>
        <div v-else>
          <h5 class="font-bold pt-base">Commission not found for staff</h5>
        </div>
    </div>
    <div v-if="type == 'salary'">
      <div v-if="this.commissionList.salary != null">
        <h5 class="font-bold pt-base">
          <span v-if="this.commissionList.salary.salary_type == 1">Wage per hour</span>
          <span v-else>Salary by period</span>
        </h5>
        <p class="font-bold text-primary mt-3">
          <span v-if="this.commissionList.salary.salary_type == 1">{{+(Math.round(this.commissionList.salary.salary_per_hour + "e+3") + "e-3")}}</span>
          <span v-else>{{+(Math.round(this.commissionList.salary.salary_by_period + "e+3") + "e-3")}}</span>
        </p>

        <h5 class="font-bold pt-base">Cash - Check Percentage</h5>
        <p class="font-bold text-primary mt-3">{{formatPercent(this.commissionList.salary.cash_check_percentage)}} - {{formatPercent(1 - this.commissionList.salary.cash_check_percentage)}}</p>

        <h5 class="font-bold pt-base">Percentage Charge For Credit Card Tips</h5>
        <p class="font-bold text-primary mt-3 mb-6">{{formatFloatNum(this.commissionList.salary.tip_to_check_percentage)}}%</p>
      </div>
      <div v-else>
        <h5 class="font-bold pt-base">Commission not found for staff</h5>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { StringHelper } from "../../models/string_helper";
export default {
  name: "staff-info",
  props: {
    activeStaffData: {
      type: Object,
      required: true
    },
    filter: {
      type: Number
    },
    currentPage: {
      type: Number,
      required: true
    },
    itemsPerPage: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      StringHelper,
      status: this.activeStaffData.status,
      popupActive: false,
      popupStaffSetting: false,
      isOpenLoading: false,
      booking: this.activeStaffData.booking_active,
      type: this.activeStaffData.commission_type ? this.activeStaffData.commission_type : 'commission',
      commission_type: this.activeStaffData.commission_type,
      staff_setting_type: '',
    };
  },
  computed: {
    commissionList(){
      return this.$store.getters["staffList/commissionList"];
    },
    staff_status: {
      get() {
        return this.status;
      },
      set(value) {
        this.status = value;
      }
    },
    booking_active: {
      get() {
        return this.booking;
      },
      set(value) {
        this.booking = value;
      }
    },
    config(){
      return this.$store.getters['auth/config'];
    }
  },
  methods: {
    formatPercent(value) {
      // return Math.round((value/100) * 100 + Number.EPSILON ) / 100;
      return +(Math.round(value*100 + "e+2") + "e-2");
    },
    formatFloatNum(value) {
      return +(Math.round(value*100 + "e+5") + "e-5");
    },
    staffSettingCommission(){
      if(this.commissionList.commission != null){
        if(this.staff_setting_type == this.commission_type){
          this.popupStaffSetting = false;
        }else{
          this.popupStaffSetting = true;
        }
      }
    },
    staffSettingSalaryCommission(){
      if(this.commissionList.salary_commission != null){
        if(this.staff_setting_type == this.commission_type){
          this.popupStaffSetting = false;
        }else{
          this.popupStaffSetting = true;
        }
      }
    },
    staffSettingSalary(){
      if(this.commissionList.salary != null){
        if(this.staff_setting_type == this.commission_type){
          this.popupStaffSetting = false;
        }else{
          this.popupStaffSetting = true;
        }
      }
    },
    changeStaffSetting(){
      const obj = {
        id:  this.activeStaffData.user_id,
        commission_type: this.staff_setting_type,
        filter: this.filter,
        page: this.currentPage,
        "per-page": this.itemsPerPage,
        is_active: !this.status ? 1 : 0,
        staff_code: this.StringHelper.staffCodeFormat(
          this.activeStaffData.code
        ),
        image_url: this.activeStaffData.image_url
      }
      this.$store.dispatch("staffList/CHANGE_STAFF_COMMISSION", obj)
      .then(() => {
        this.closeLoading();
        const staff_data = JSON.parse(JSON.stringify(this.activeStaffData));
        staff_data.commission_type = this.staff_setting_type;
        this.$emit("ChangeStaffSetting", staff_data);
        this.$vs.notify({
          title: "Notification",
          text: "Update Setting Staff Success",
          color: "success",
          position: "top-right"
        });
      })
      .catch(() => {
        this.closeLoading();
        this.$vs.notify({
          title: "Notification",
          text: "Update Setting Staff Fail",
          color: "danger",
          position: "top-right"
        });
      });
      this.popupStaffSetting = false;
    },
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#staff-list",
        scale: 0.8
      });
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout(() => {
        if (this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: "danger",
            title: "Notification",
            text: "Update status failed",
            acceptText: "OK"
          });
        }
      }, 10000);
      // setTimeout( ()=> {
      //   this.$vs.loading.close('#staff-list > .con-vs-loading')
      // }, 500);
    },
    closeLoading() {
      this.$vs.loading.close("#staff-list > .con-vs-loading");
      this.isOpenLoading = false;
    },
    editData() {
      this.$emit("EditStaff", this.activeStaffData);
    },
    // switchActive() {
    //     this.status = !this.status;
    // },
    openPopupChangeStatus() {
      this.status = !this.status;
      this.popupActive = true;
    },
    closePopup() {
      this.popupActive = false;
    },
    changeStatus() {
      const staff = {
        id: this.activeStaffData.user_id,
        is_active: !this.status ? 1 : 0,
        staff_code: this.StringHelper.staffCodeFormat(
          this.activeStaffData.code
        ),
        filter: this.filter,
        page: this.currentPage,
        "per-page": this.itemsPerPage,
        image_url: this.activeStaffData.image_url,
        address: this.activeStaffData.address,
        phone: this.activeStaffData.phone,
        nick_name: this.activeStaffData.nickname,
      };
      if (!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.closePopup();
      this.$store
        .dispatch("staffList/UPDATE_STAFF", staff)
        .then(() => {
          this.closeLoading();
          this.popupActive = false;
          const staff_data = JSON.parse(JSON.stringify(this.activeStaffData));
          staff_data.status = !this.status ? 1 : 0;
          this.$emit("ChangeStaffStatus", staff_data);
          this.$vs.notify({
            title: "Notification",
            text: "Update Status Success",
            color: "success",
            position: "top-right"
          });
        })
        .catch(() => {
          this.closeLoading();
          this.$vs.notify({
            title: "Notification",
            text: "Update Status Fail",
            color: "danger",
            position: "top-right"
          });
        });
    },
    changeBookingActive() {
      if (!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      let staff = {
        id: this.activeStaffData.user_id,
        is_active: !this.booking ? 1 : 0,
        filter: this.filter,
        page: this.currentPage,
        "per-page": this.itemsPerPage
      };
      this.$store
        .dispatch("staffList/UPDATE_BOOKING_STAFF", staff)
        .then(() => {
          this.closeLoading();
          this.$vs.notify({
            title: "Notification",
            text: "Update Appointment Success",
            color: "success",
            position: "top-right"
          });
        })
        .catch(() => {
          this.closeLoading();
          this.booking = false;
          this.$vs.dialog({
            color: "danger",
            title: `Staff reach limit`,
            text: "Please contact us for more info at: 832-968-6668."
          });
        });
    },
    editCommission() {
      this.$emit('EditCommission');
    }
  },

  created(){
    const obj = {
      staff_id : this.activeStaffData.user_id
    }
    if(this.config && this.config.pos_feature == 1) {
      this.$store.dispatch("staffList/LIST_COMMISSION_BY_STAFF", obj).then(() => {
        // this.commissionList = this.$store.getters["staffList/commissionList"];
      })
    }
  }
};
</script>
